const actions = {
  SITES_ERROR: "SITES_ERROR",
  GET_SITES_REQUEST: "GET_SITES_REQUEST",
  GET_SITES_SUCCESS: "GET_SITES_SUCCESS",
  GET_SITE_REQUEST: "GET_SITE_REQUEST",
  GET_SITE_SUCCESS: "GET_SITE_SUCCESS",
  DELETE_SITE_REQUEST: "DELETE_SITE_REQUEST",
  DELETE_SITE_SUCCESS: "DELETE_SITE_SUCCESS",
  UPDATE_SITE_REQUEST: "UPDATE_SITE_REQUEST",
  UPDATE_SITE_SUCCESS: "UPDATE_SITE_SUCCESS",
  CREATE_SITE_REQUEST: "CREATE_SITE_REQUEST",
  CREATE_SITE_SUCCESS: "CREATE_SITE_SUCCESS",
  ADD_SITE_DATA_SOURCE_REQUEST: "ADD_SITE_DATA_SOURCE_REQUEST",
  ADD_SITE_DATA_SOURCE_SUCCESS: "ADD_SITE_DATA_SOURCE_SUCCESS",
  REMOVE_SITE_DATA_SOURCE_REQUEST: "REMOVE_SITE_DATA_SOURCE_REQUEST",
  REMOVE_SITE_DATA_SOURCE_SUCCESS: "REMOVE_SITE_DATA_SOURCE_SUCCESS",
  UPDATE_SITE_DEMAND_CONFIG_REQUEST: "UPDATE_SITE_DEMAND_CONFIG_REQUEST",
  UPDATE_SITE_DEMAND_CONFIG_SUCCESS: "UPDATE_SITE_DEMAND_CONFIG_SUCCESS",

  // Local actions
  SET_SELECTED_SITE_ID: "SET_SELECTED_SITE_ID",

  getSites: token => {
    return {
      type: actions.GET_SITES_REQUEST,
      token
    };
  },
  getSiteById: (token, id) => {
    return {
      type: actions.GET_SITE_REQUEST,
      token,
      id
    };
  },
  deleteSite: (token, id) => {
    return {
      type: actions.DELETE_SITE_REQUEST,
      token,
      id
    };
  },
  updateSite: (token, site) => {
    return {
      type: actions.UPDATE_SITE_REQUEST,
      token,
      site
    };
  },
  createSite: (token, site) => {
    return {
      type: actions.CREATE_SITE_REQUEST,
      token,
      site
    };
  },
  addSiteDataSource: (token, siteId, zoneId, circuitId, dataSourceType, positive = true) => {
    return {
      type: actions.ADD_SITE_DATA_SOURCE_REQUEST,
      token,
      siteId,
      zoneId,
      circuitId,
      dataSourceType,
      positive
    };
  },
  removeSiteDataSource: (token, siteId, zoneId, circuitId, dataSourceType) => {
    return {
      type: actions.REMOVE_SITE_DATA_SOURCE_REQUEST,
      token,
      siteId,
      zoneId,
      circuitId,
      dataSourceType
    };
  },
  setSelectedSiteId: siteId => {
    return {
      type: actions.SET_SELECTED_SITE_ID,
      siteId
    };
  },
  updateSiteDemandConfig: (token, siteId, demandSwitch, demandThreshold) => {
    return {
      token,
      type: actions.UPDATE_SITE_DEMAND_CONFIG_REQUEST,
      siteId,
      demandSwitch,
      demandThreshold
    };
  }
};

const sitesActions = actions;

export default sitesActions;
